import { render } from "./RemoveAccountView.vue?vue&type=template&id=f6bb857a&scoped=true&ts=true"
import script from "./RemoveAccountView.vue?vue&type=script&lang=ts"
export * from "./RemoveAccountView.vue?vue&type=script&lang=ts"

import "./RemoveAccountView.vue?vue&type=style&index=0&id=f6bb857a&scoped=true&lang=css"
import "./RemoveAccountView.vue?vue&type=style&index=1&id=f6bb857a&lang=css"
import "./RemoveAccountView.vue?vue&type=style&index=2&id=f6bb857a&lang=css"
import "./RemoveAccountView.vue?vue&type=style&index=3&id=f6bb857a&lang=css"
import "./RemoveAccountView.vue?vue&type=style&index=4&id=f6bb857a&lang=css"
import "./RemoveAccountView.vue?vue&type=style&index=5&id=f6bb857a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6bb857a"]])

export default __exports__